import * as PATHS from '@/constants/path';
import { request } from '@/services/api/request';
import { URLParamBuilder } from '@/utils/functions';

const TRICKPARK_INTEGRATION_TYPE = 'trickpark';

export function installTrickparkRequest() {
  const url = URLParamBuilder(PATHS.INTEGRATION_GENERIC_ENABLE, {
    params: { integrationType: TRICKPARK_INTEGRATION_TYPE },
  });
  return request<any>(url, {
    method: 'POST',
  });
}

export function getTrickparkIntegrationRequest() {
  return request<any>(PATHS.TRICKPARK_INTEGRATION_STATUS, {
    method: 'GET',
  });
}

export function uninstallTrickparkRequest() {
  const url = URLParamBuilder(PATHS.INTEGRATION_GENERIC_DISABLE, {
    params: { integrationType: TRICKPARK_INTEGRATION_TYPE },
  });
  return request<any>(url, {
    method: 'DELETE',
  });
}

export function fetchTrickparkUserMappingsRequest() {
  return request<any>(PATHS.TRICKPARK_USER_MAPPINGS, {
    method: 'GET',
  });
}

export function createTrickparkUserMappingRequest({ data }) {
  return request<any>(PATHS.TRICKPARK_USER_MAPPINGS, {
    method: 'POST',
    data,
  });
}

export function updateTrickparkUserMappingRequest({ params, data }) {
  const url = URLParamBuilder(PATHS.TRICKPARK_USER_MAPPING, { params });
  return request<any>(url, {
    method: 'PUT',
    data,
  });
}

export function deleteTrickparkUserMappingRequest({ params }) {
  const url = URLParamBuilder(PATHS.TRICKPARK_USER_MAPPING, { params });
  return request<any>(url, {
    method: 'DELETE',
  });
}

export function fetchTrickparkSessionsRequest({ query = {} } = {}) {
  const url = URLParamBuilder(
    PATHS.TRICKPARK_SESSIONS,
    { queryString: query },
    false,
  );
  return request<any>(url, {
    method: 'GET',
  });
}
